import React, { useState, useEffect } from 'react';
import '../otp-verify/otp.css';
import { postWithoutTokenAPI } from '../../utils/Api';
import { useLocation, useNavigate } from 'react-router-dom';
import phone from '../../AdminDashboard/image/phone1.svg';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';


const OTPVerification = () => {
  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [timer, setTimer] = useState(30);
  // const [timer, setTimer] = useState(60);
  const navigate = useNavigate();
  const location = useLocation();

  const phone_number = location.state?.phone_number;
  const fromForgotPassword = location.state?.fromForgotPassword;

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(countdown);
    }
  }, [timer]);

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;
    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const handleSubmit = async () => {
    const otpCode = otp.join("");
    setError("");
    setSuccess("");

    if (otpCode.length !== 4) {
      setError("Please enter a valid 4-digit OTP.");
      return;
    }

    try {
      const response = await postWithoutTokenAPI("/auth/otpverify", {
        phone_number,
        otp: otpCode,
      });

      if (response.statusCode === 200) {
        // toast.success("OTP verified successfully!");

        setTimeout(() => {  
          if (fromForgotPassword) {
            navigate("/admin/Forgot", { state: { phone_number } });
          } else {
            navigate("/admin/signin", { state: { phone_number } });
          }
        }, 1500);
      } else {
        setError(response.message || "OTP verification failed.");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    }
  };

  const handleResend = async () => {
  try {
      const response = await postWithoutTokenAPI("/auth/send-otp", { phone_number });
      if (response.statusCode === 200) {
        // toast.success("OTP resent successfully!");
                setTimer(30); // reset the timer


      } else {
        setError(response.message || "Failed to resend OTP.");
      }
    } catch (err) {
      setError("Error while resending OTP. Please try again.");
    }
  };

  return (
    <div className="otp-container">
            {/* <ToastContainer autoClose={3000} /> */}

      <div className="otp-box">

        <img src={phone} alt="verify" className="otp-icon" />
        <h4>Verify Your Phone number</h4>

    
        <div className="otp-inputs">
          {otp.map((data, index) => (
            <input
              type="text"
              name="otp"
              maxLength="1"
              key={index}
              value={otp[index]}
              onChange={(e) => handleChange(e.target, index)}
              onFocus={(e) => e.target.select()}
            />
          ))}
        </div>

        {error && <div className="otp-error">{error}</div>}
        {success && <div className="otp-success">{success}</div>}

        <button className="otp-verify-btn" onClick={handleSubmit}>Verify</button>

        {timer > 0 ? (
          <p className="otp-resend">Resend Code in <strong>{timer}s</strong></p>
        ) : (
          <p className="otp-resend">
            Didn’t receive the code? <span onClick={handleResend} className="otp-resend-link">Resend Code</span>
          </p>
        )}
      </div>
    </div>  
  );
};

export default OTPVerification;
